export type ClassValue =
  | string
  | number
  | bigint
  | null
  | false
  | undefined
  | ClassValue[];

/**
 * Minimal className joiner. Filters falsy values and flattens arrays.
 * Kept dependency-free; author base classes so caller overrides come last.
 */
export function cn(...values: ClassValue[]): string {
  const out: string[] = [];
  for (const value of values) {
    if (!value) continue;
    if (Array.isArray(value)) {
      const nested = cn(...value);
      if (nested) out.push(nested);
    } else {
      out.push(String(value));
    }
  }
  return out.join(" ");
}
